<!-- =================================================================== -->
<!-- Card da tabela (header com filtros inline + tabela lazy)             -->
<!-- Mesmo padrao da aba "Repasse de Comissoes": header em 2 regioes      -->
<!-- (titulo / filtros) e rodape de paginacao. Tela READ-ONLY.            -->
<!-- =================================================================== -->
<div class="table-card">
  <div class="card-header card-header-table">
    <!-- Regiao esquerda: icone + titulo -->
    <div class="card-header-left">
      <div class="card-header-icon table-icon">
        <i class="pi pi-history"></i>
      </div>
      <span class="card-header-title">{{ 'contador.historico_pagamentos.titulo' | translate }}</span>
    </div>

    <!-- Regiao central: periodo + pessoa indicadora + comissao de origem (cascata) -->
    <div class="card-header-filters">
      <div class="header-filter-field">
        <!-- Datas repassadas CRUAS ("dd/MM/yyyy'T'HH:mm"). Nunca ISO (=> 422). -->
        <app-periodo-filtro
          [modo]="'avancado'"
          [valorPadrao]="'showAll'"
          styleClass="w-full"
          [placeholder]="'contador.historico_pagamentos.filtros.periodo_placeholder' | translate"
          (periodoChanged)="onPeriodoChanged($event)">
        </app-periodo-filtro>
      </div>

      <!-- Pessoa indicadora que RECEBEU o pagamento (indicadorId). -->
      <div class="header-filter-field">
        <p-dropdown
          [options]="indicadorOptions"
          [(ngModel)]="indicadorSelecionadoId"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
          [placeholder]="'contador.historico_pagamentos.filtros.indicador_placeholder' | translate"
          (onChange)="onIndicadorChange()">
        </p-dropdown>
      </div>

      <!-- Camada 1 da cascata: sem indicador o combo fica desabilitado (o backend
           responde 422 se comissaoId for enviado sozinho). O tooltip explica o porque. -->
      <div class="header-filter-field"
           [pTooltip]="comissaoDesabilitada ? ('contador.historico_pagamentos.filtros.comissao_desabilitado_hint' | translate) : null"
           tooltipPosition="top">
        <p-dropdown
          [options]="comissaoOptions"
          [(ngModel)]="comissaoSelecionadaId"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
          [disabled]="comissaoDesabilitada"
          [placeholder]="carregandoComissoes
            ? ('contador.historico_pagamentos.filtros.comissao_carregando' | translate)
            : ('contador.historico_pagamentos.filtros.comissao_placeholder' | translate)"
          [emptyMessage]="'contador.historico_pagamentos.filtros.comissao_vazio' | translate"
          (onChange)="onComissaoChange()">
        </p-dropdown>
      </div>

      <!-- Exportar: download direto do PDF do historico de pagamentos com os filtros atuais.
           Excel/CSV existem no backend e no service, mas ficam fora da UI neste primeiro
           momento (decisao de produto '07-27); para reativar, restaurar o p-menu com
           exportarItens (PDF / Excel / CSV) como na aba "Repasse de Comissoes". -->
      <div class="header-filter-action">
        <button pButton
          type="button"
          icon="pi pi-file-export"
          class="p-button-outlined p-button-secondary btn-sm"
          style="gap: 0.35rem"
          [label]="'contador.historico_pagamentos.exportar.botao' | translate"
          [pTooltip]="'contador.historico_pagamentos.exportar.tooltip' | translate"
          tooltipPosition="top"
          [attr.aria-label]="'contador.historico_pagamentos.exportar.tooltip' | translate"
          [disabled]="exportando"
          [loading]="exportando"
          (click)="exportarPdf()">
        </button>
      </div>
    </div>
  </div>

  <div class="card-content">

    <p-table [value]="pagamentos"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [loading]="loading"
      sortField="dataPagamento"
      [sortOrder]="-1"
      [tableStyle]="{ width: '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3.5rem"></th>
          <th style="width: 20%" pSortableColumn="dataPagamento">
            {{ 'contador.historico_pagamentos.col_data_pagamento' | translate }}
            <p-sortIcon field="dataPagamento"></p-sortIcon>
          </th>
          <th style="width: 24%">{{ 'contador.historico_pagamentos.col_indicador' | translate }}</th>
          <th style="width: 20%">{{ 'contador.historico_pagamentos.col_pago_por' | translate }}</th>
          <th style="width: 10%">{{ 'contador.historico_pagamentos.col_qtd_comissoes' | translate }}</th>
          <th style="width: 16%" pSortableColumn="valorTotal">
            {{ 'contador.historico_pagamentos.col_valor_total' | translate }}
            <p-sortIcon field="valorTotal"></p-sortIcon>
          </th>
          <th style="width: 10%">{{ 'contador.historico_pagamentos.col_acoes' | translate }}</th>
        </tr>
      </ng-template>

      <!-- Duas <tr> por linha: a linha normal e, quando expandida, a linha de detalhe
           com colspan="7". Expansao pelo mapa manual `expandedRows` (padrao do
           projeto), sem a API rowExpansion do PrimeNG. -->
      <ng-template pTemplate="body" let-pagamento>
        <tr>
          <td>
            <button pButton
              type="button"
              class="p-button-text p-button-rounded p-button-sm p-button-plain"
              [icon]="isExpandido(pagamento) ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
              [pTooltip]="(isExpandido(pagamento)
                ? 'contador.historico_pagamentos.detalhe.recolher'
                : 'contador.historico_pagamentos.detalhe.expandir') | translate"
              tooltipPosition="top"
              [attr.aria-label]="(isExpandido(pagamento)
                ? 'contador.historico_pagamentos.detalhe.recolher'
                : 'contador.historico_pagamentos.detalhe.expandir') | translate"
              [attr.aria-expanded]="isExpandido(pagamento)"
              (click)="toggleExpand(pagamento)">
            </button>
          </td>
          <td>{{ dataHoraLabel(pagamento.dataPagamento) }}</td>
          <td>{{ pagamento.indicadorNome || '—' }}</td>
          <td>{{ pagamento.usuarioPagamentoNome || '—' }}</td>
          <td>{{ pagamento.quantidadeComissoes }}</td>
          <td>{{ pagamento.valorTotal | guaraniFormat }}</td>
          <td class="actions">
            <button pButton
              type="button"
              icon="pi pi-print"
              class="p-button-text p-button-rounded p-button-sm p-button-plain"
              [pTooltip]="'contador.historico_pagamentos.comprovante.tooltip' | translate"
              tooltipPosition="top"
              [attr.aria-label]="'contador.historico_pagamentos.comprovante.botao' | translate"
              [loading]="imprimindoPagamentoId === pagamento.id"
              [disabled]="imprimindoPagamentoId === pagamento.id"
              (click)="imprimirComprovante(pagamento)">
            </button>
          </td>
        </tr>

        <!-- Linha de detalhe: comissoes de origem abatidas neste pagamento.
             Os dados ja vieram no payload da listagem (sem requisicao extra) e a
             ordem (competencia ASC) e garantida pelo backend — nao reordenar. -->
        <tr *ngIf="isExpandido(pagamento)" class="detalhe-row">
          <td colspan="7">
            <div class="detalhe-box">
              <span class="detalhe-titulo">
                {{ 'contador.historico_pagamentos.detalhe.titulo' | translate }}
              </span>

              <table class="detalhe-tabela" *ngIf="pagamento.comissoes?.length > 0; else detalheVazio">
                <thead>
                  <tr>
                    <th>{{ 'contador.historico_pagamentos.detalhe.col_comissao' | translate }}</th>
                    <th>{{ 'contador.historico_pagamentos.detalhe.col_competencia' | translate }}</th>
                    <th>{{ 'contador.historico_pagamentos.detalhe.col_valor_pago' | translate }}</th>
                    <th>{{ 'contador.historico_pagamentos.detalhe.col_status' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let comissao of pagamento.comissoes">
                    <td>#{{ comissao.comissaoId }}</td>
                    <td>{{ dataLabel(comissao.competencia) }}</td>
                    <td>{{ comissao.valorPago | guaraniFormat }}</td>
                    <td>
                      <p-tag
                        [value]="labelStatus(comissao.statusRepasse)"
                        [severity]="severityStatus(comissao.statusRepasse)">
                      </p-tag>
                    </td>
                  </tr>
                </tbody>
              </table>

              <ng-template #detalheVazio>
                <span class="detalhe-vazio">
                  {{ 'contador.historico_pagamentos.detalhe.vazio' | translate }}
                </span>
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Corpo vazio: a consulta pode ter falhado (erroCarregar) ou simplesmente nao
           ter registros. Os dois casos precisam de mensagens DIFERENTES — senao a
           falha se disfarca de "nao existe historico" quando o toast some. -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center p-5">
            <div *ngIf="erroCarregar; else listaVazia" class="flex flex-column align-items-center">
              <i class="pi pi-exclamation-triangle text-orange-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ 'contador.historico_pagamentos.erros.generico' | translate }}</div>
            </div>

            <ng-template #listaVazia>
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ 'contador.historico_pagamentos.vazio' | translate }}</div>
              </div>
            </ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td colspan="7" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ 'contador.historico_pagamentos.carregando' | translate }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao (mesmo modelo da aba irma): contagem a esquerda,
         "Itens por pagina" + dropdown a direita. Tabela lazy: recarrega do backend. -->
    <div class="pagination-container">
      <div>
        <p-paginator
          (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'contador.historico_pagamentos.contagem' | translate"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ 'contador.historico_pagamentos.itens_por_pagina' | translate }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
          appendTo="body">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<p-toast />
